import { Typography } from '@mui/material';
import store from '../../../../store';

const TeacherFullName = ({ value }) => {
    const teachers =
        (store.getState().groups &&
            store.getState().groups.teacher_select &&
            store.getState().groups.teacher_select.teacher) ||
        [];
    let full_name = '';
    if (typeof value === 'string') {
        full_name = value;
    } else if (value && typeof value === 'object' && value.first_name && value.last_name) {
        full_name = `${value.last_name} ${value.first_name}`;
    } else {
        const teacher = teachers.find((teacher) => teacher.id == value);
        if (teacher && teacher.last_name && teacher.first_name) {
            full_name = `${teacher.last_name} ${teacher.first_name}`;
        }
    }

    return (
        <Typography>{full_name}</Typography>
    );
};

export default TeacherFullName;
